import { MockCard, MockKpiCard } from '../../components/mockups/MockUI'
import { MockTable } from '../../components/mockups/MockTable'

export function ProcDashboardOverview() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
          Дашборд закупщика
        </h2>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Дашборд закупщика показывает личную статистику: сколько позиций в работе, сколько квот
          дано, какие позиции «зависли» без ответа, напоминания о просроченных.
        </p>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
        <MockKpiCard value="45" label="В очереди" color="brand" />
        <MockKpiCard value="128" label="Квот за месяц" color="green" />
        <MockKpiCard value="7" label="Без движения >3д" color="red" />
        <MockKpiCard value="73%" label="Доля закрытых" color="blue" />
      </div>
      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400 space-y-2">
          <div className="font-medium text-gray-800 dark:text-gray-200">Блоки дашборда:</div>
          <ul className="list-disc list-inside space-y-1">
            <li>KPI-карточки — кликабельные, открывают drill-down</li>
            <li>Таблица «Без движения» — позиции, по которым нет ответа более 3 дней</li>
            <li>Топ запрашиваемых партномеров — что ищут чаще всего</li>
            <li>Таблица поставщиков — с кем вы работаете, сколько квот</li>
            <li>График «Квоты за день» — динамика работы</li>
          </ul>
        </div>
      </MockCard>
    </div>
  )
}

export function ProcDashboardStats() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
          Статистика квот
        </h2>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Детальная статистика по вашим квотам (котировкам) за выбранный период.
        </p>
      </div>
      <MockTable
        caption="Статистика по поставщикам"
        columns={[
          { header: 'Поставщик' },
          { header: 'Квот' },
          { header: 'Среднее время' },
          { header: 'Последняя' },
        ]}
        rows={[
          ['Chipsmall', '34', '2.1 дня', '17.04.26'],
          ['Win Source', '28', '1.8 дня', '16.04.26'],
          ['LCSC', '15', '3.5 дня', '15.04.26'],
          ['Прямой производитель', '8', '5.0 дней', '14.04.26'],
        ]}
      />
      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400">
          Клик на строку поставщика открывает модалку с деталями: список позиций, средние цены,
          историю ответов.
        </div>
      </MockCard>
    </div>
  )
}
